"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, useContext } from "react";
import TabContext from "./TabsContext.mjs";
import cx from "classnames";
import { onTabPanelKeyDown } from "./utils/index.mjs";
const TabPanel = forwardRef(
  (props, ref) => {
    const {
      prefix = "",
      className,
      title,
      children,
      text,
      tabPanelId,
      ...otherProps
    } = props;
    const classes = cx(`${prefix}tabs__panel`, className);
    const ctx = useContext(TabContext);
    return /* @__PURE__ */ jsxs(
      "div",
      {
        ...otherProps,
        ref,
        tabIndex: -1,
        className: classes,
        id: tabPanelId,
        hidden: ctx.activeTab !== tabPanelId,
        onKeyDown: (e) => {
          if (ctx.activeTab) {
            onTabPanelKeyDown(e, ctx.activeTab, ctx.root || void 0);
          }
        },
        role: "tabpanel",
        children: [
          title && /* @__PURE__ */ jsx("h2", { className: `${prefix}tabs__panel-title`, children: title }),
          text && /* @__PURE__ */ jsx("p", { children: text }),
          children && children
        ]
      }
    );
  }
);
TabPanel.displayName = "TabPanel";
var TabPanel_default = TabPanel;
export {
  TabPanel,
  TabPanel_default as default
};
